export default __webpack_public_path__ + "bdc9a3a86715361d8ba36d77e2ae4193.png";